export default __webpack_public_path__ + "static/media/floor1.3b89fc81.svg";